import { useTranslation, Trans } from 'react-i18next'
import { OreStack, OreText, OreWysiwyg } from '@edenredespana/oreneta'
import { storesTranslation } from '@/Store/ui/storesTranslation'

export const ExcelUploaderInfo = (): JSX.Element => {
    const { t } = useTranslation()

    return (
        <OreStack space="large">
            <>
                <OreStack space="large">
                    <OreWysiwyg>
                        <OreText>
                            {t(storesTranslation.excelTpvUpload.description)}
                        </OreText>
                        <ol style={{ listStyle: 'numeric', padding: '0', marginLeft: '1.5rem', color: '#475569' }}>
                            <li style={{ marginTop: '0' }}><Trans components={{ strong: <strong /> }}>{t(storesTranslation.excelTpvUpload.listItem1)}</Trans></li>
                            <li style={{ marginTop: '0' }}>
                                <Trans
                                    t={t}
                                    components={[<span style={{ fontWeight: 'bold', textDecoration: 'underline' }} /> ]}>
                                    {t(storesTranslation.excelTpvUpload.listItem2)}
                                </Trans>
                            </li>
                            <li style={{ marginTop: '0' }}><Trans components={{ strong: <strong /> }}>{t(storesTranslation.excelTpvUpload.listItem3)}</Trans></li>
                        </ol>
                    </OreWysiwyg>
                </OreStack>
            </>
        </OreStack>
    )
}
